'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global isEmpty*/
/*global initialize*/
(function ($) {
  var methods = {
    init: function (/*options*/) {
      /*var opts = $.extend({}, $.fn.detailLoader.defaults, options);*/

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('detail-loader-init')) {
          return;
        }

        $this.addClass('detail-loader-init');
        $this.on('click', function (/*e*/) {
          methods.load.apply(_this, []);
          return false;
        });
      });
    },

    load: function () {
      var $this = $(this);

      var $row = $this.closest('tr');
      $row.toggleClass('success');
      var $detailRow = $row.next('tr');
      $detailRow.toggleClass('hidden');
      var $detailTd = $detailRow.find('td');

      if ($row.hasClass('success')) {
        $this.find('.glyphicon').removeClass('glyphicon-triangle-right').addClass('glyphicon-triangle-bottom');
      } else {
        $this.find('.glyphicon').removeClass('glyphicon-triangle-bottom').addClass('glyphicon-triangle-right');
      }

      if (isEmpty($detailTd.html())) {
        blockElement($detailTd);
        $.get($this.attr('href'), function (res) {
          unBlockElement($detailTd);
          $detailTd.html(res);
          initialize($detailTd);
        });
      }
    }
  };

  $.fn.detailLoader = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.detailLoader');
    }

  };

  $.fn.detailLoader.defaults = {};

})(jQuery);
